import React, { useState } from "react";
import "./styles/App.css";
import { PageLayout } from "./components/authentication/PageLayout";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import Button from "react-bootstrap/Button";
import { loginRequest } from "./authConfig";
import { ProfileData } from "./components/authentication/ProfileData";
import { Routes, Route, Link } from "react-router-dom";
import Home from './pages/Home';
import About from './pages/About';
import WhatsNew from './pages/WhatsNew';
import HelpPage from './features/help/HelpPage';
import BomViewerPage from './features/bomViewer/BomViewerPage';
import ComparisonViewerPage from './features/bomViewer/ComparisonViewerPage';
import { COMPARISON_VIEWER } from "./features/bomViewer/flags";
import axios from 'axios';
import appConfig from "./appConfig";

/**
 * Renders information about the signed-in user or a button to retrieve data about the user
 */
const ProfileContent = () => {
  const { instance, accounts } = useMsal();

  function RequestProfileData() {
    // Silently acquires an access token which is then attached to a request for MS Graph data
    instance
      .acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      .then((response) => {
        // callMsGraph(response.accessToken).then((response) =>
        //   setGraphData(response)
        // );
        callApiWithAxios(response.accessToken);
        console.log(response.accessToken);
      });
  }


  const callApiWithAxios = async (accessToken) => {
    try {
  
      const options = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
  
      const response = await axios.get(`${appConfig.apiUrl}users`, options);
      console.log('API Response:', response.data);

    } catch (error) {
      console.error('API Call Error:', error);
      
    }
  };  

  return (
    <>
      <h5 className="card-title">Welcome {accounts[0].name}</h5>
      
    </>
  );
};

/**
 * If a user is authenticated the ProfileContent component above is rendered. Otherwise a message indicating a user is not authenticated is rendered.
 */
const MainContent = () => {
  return (
    <div className="App">
      <AuthenticatedTemplate>
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/whats-new" element={<WhatsNew />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/bom/:outputId" element={<BomViewerPage />} />
        {COMPARISON_VIEWER && <Route path="/compare/:inputId" element={<ComparisonViewerPage />} />}
      </Routes>         
      </AuthenticatedTemplate>     
    </div>
  );
};

export default function App() {
  return (
    <PageLayout>
      <MainContent />
    </PageLayout>
  );
}
